<template>
  <div>
    <p style="position: absolute;left: -999999px;">{{ changeInfoTemp }}</p>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-orders'>{{translations('navbar.sale_management')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-orders'>{{translations('order.archive_order')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('order.register_order')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <div v-show="Number(outsourcingstatus) !== 1" class='form-inline mb-3'>
            <div class='form-group'>
              <button class='btn btn-primary disabled'>{{translations('order.shipping_process')}}</button>
            </div>
          </div>
          <div v-show="Number(outsourcingstatus) > 0" class='form-inline mb-3'>
            <div class='form-group'>
              <button class='btn btn-success disabled mr-2'>{{translations('order.delivery_processing')}}</button>
              <button class='btn btn-success disabled'>{{translations('order.register_sales')}}</button>
            </div>
          </div>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{translations('order.order_date')}}</th>
                <td>
                  <button
                    ref='info01'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info01'
                    data-placement='right'
                  >{{ ordersInfo.ordered_at ? $invoiceTools.formatDateAt(ordersInfo.ordered_at) : '-----------' }}</button>
                  <div id='popover-info01' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.order_date')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='date' v-model="tempInfo.ordered_at" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('ordered_at', tempInfo.ordered_at, 'info01')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('order.division')}}</th>
                <td>
                  <button
                    ref='info02'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info02'
                    data-placement='right'
                  >
                    <DivisionTypeText :division_type="tempInfo.division_type" labelDefault='-----------' />
                  </button>
                  <div id='popover-info02' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.division')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <select
                        class='form-control'
                        v-model="tempInfo.division_type_select">
                        <option value="null">-----------</option>
                        <option
                          :disabled="type.value === 'D'"
                          v-for="type in DivisionTypes"
                          :key="type.value"
                          :value="type.value"
                        >
                          {{type.label}}
                        </option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('division_type', tempInfo.division_type_select, 'info02')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('order.order_number')}}</th>
                <td>
                  <button
                    ref='info03'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info03'
                    data-placement='right'
                  >{{ ordersInfo.order_number ? ordersInfo.order_number : '-----------' }}</button>
                  <div id='popover-info03' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.order_number')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input ref='input-info03' type='text' v-model="tempInfo.order_number" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('order_number', tempInfo.order_number, 'info03')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-show="ordersInfo.division_type !== 'B'">
                <th>{{translations('order.bill_to')}}</th>
                <td>
                  <button
                    ref='info04'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info04'
                    data-placement='right'
                  >{{ ordersInfo.client_name ? ordersInfo.client_name : '-----------' }}</button>
                  <div id='popover-info04' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.bill_to')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="billings" label="name" value="id" v-model="tempInfo.client"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('client_id', tempInfo.client, 'info04')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-show="ordersInfo.division_type === 'B'">
                <th>{{translations('order.bill_to')}}</th>
                <td>
                  <button
                    ref='info005'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info005'
                    data-placement='right'
                  >{{ ordersInfo.warehouse_address_from ? ordersInfo.warehouse_address_from : '-----------' }}</button>

                  <div id='popover-info005' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.bill_to')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <div class="warehouse_style">
                      <v-select
                        :options="warehouses"
                        value="id"
                        v-model="tempInfo.warehouse_id_from"
                        label="name"
                      >
                        <template slot="selected-option" slot-scope="option">
                          {{ option.name }}
                        </template>
                        <template v-slot:option="option">
                          {{ option.name }}
                        </template>
                    </v-select>
                  </div>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('warehouse_id_from', tempInfo.warehouse_id_from, 'info005')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-show="ordersInfo.division_type === 'B'">
                <th>{{translations('order.delivery_source')}}</th>
                <td>
                  <button
                    ref='info004'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info004'
                    data-placement='right'
                  >{{ ordersInfo.warehouse_address ? ordersInfo.warehouse_address : '-----------' }}</button>

                  <div id='popover-info004' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.delivery_source')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <div class="warehouse_style">
                      <v-select
                        :options="warehouses"
                        value="id"
                        v-model="tempInfo.warehouse_id"
                        label="name"
                      >
                        <template slot="selected-option" slot-scope="option">
                          {{ option.name }}
                        </template>
                        <template v-slot:option="option">
                          {{ option.name }}
                        </template>
                    </v-select>
                  </div>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('warehouse_id', tempInfo.warehouse_id, 'info004')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-show="ordersInfo.division_type !== 'B'">
                <th>{{translations('order.destination_name')}}</th>
                <td>
                  <button
                    ref='info05'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info05'
                    data-placement='right'
                  >{{ ordersInfo.destination_name ? ordersInfo.destination_name : '-----------' }}</button>
                  <div id='popover-info05' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.destination_name')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="destinations" label="name" value="id" v-model="tempInfo.destination"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('destination_id', tempInfo.destination, 'info05')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-show="ordersInfo.division_type !== 'B'">
                <th>{{translations('order.contact_person')}}</th>
                <td>
                  <button
                    ref='info06'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info06'
                    data-placement='right'
                  >{{ ordersInfo.end_user ? ordersInfo.end_user : '-----------' }}</button>
                  <div id='popover-info06' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.contact_person')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.end_user" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('end_user', tempInfo.end_user, 'info06')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-show="ordersInfo.division_type === 'B'">
                <th>{{translations('order.contact_person')}}</th>
                <td>
                  <button
                    ref='info006'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info006'
                    data-placement='right'
                  >{{ ordersInfo.users_in_charge ? ordersInfo.users_in_charge : '-----------' }}</button>
                  <div id='popover-info006' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.contact_person')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="usersList" label="user_name" value="id" v-model="tempInfo.users_in_charge"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('users_in_charge', tempInfo.users_in_charge, 'info006')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <th>{{translations('order.remarks')}}</th>
                <td>
                  <button
                    ref='info07'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info07'
                    data-placement='right'
                  >{{ ordersInfo.memo ? ordersInfo.memo : '-----------' }}</button>
                  <div id='popover-info07' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('order.remarks')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.memo" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempInfo.memo, 'info07')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <th>{{ translations('reserve.internal_memo') }}</th>
                <td>
                  <button
                    ref='info08'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info08'
                    data-placement='right'
                  >{{ ordersInfo.note ? ordersInfo.note : '-----------' }}</button>
                  <div id='popover-info08' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('reserve.internal_memo') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <textarea type='text' v-model.trim="tempInfo.note" class='form-control' maxlength="100"></textarea>
                    </div>
                    <div class='popover-footer d-flex justify-content-between'>
                      <button type="button" class="btn btn-sm btn-secondary" @click="closeModal('info08')">{{ translations('common.close') }}</button>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('note', tempInfo.note , 'info08')">{{ translations('common.keep') }}</button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <hr>
          <h5 class="mb-3">Files</h5>
          <div class="card" :class="(poFile == null) ? 'hidden' : ''">
            <ul class="list-group list-group-flush">
              <li class="list-group-item list-group-item-info d-flex justify-content-between"><a @click="openPdf()">{{translations('order.purchase_order')}}<i class="fas fa-external-link-alt"></i></a><button type="button" class="btn btn-link p-0 mr-1" @click="poFile = null"><i class="far fa-times-circle"></i></button></li>
            </ul>
          </div>
          <div class="card" :class="(poFile != null) ? 'hidden' : ''">
            <ul class="list-group list-group-flush">
              <li class="list-group-item"><button class="btn btn-link p-0" type="button" data-toggle="modal" data-target="#NewOrdersFileModal">{{translations('order.purchase_order')}}<i class="fas fa-paperclip"></i></button></li>
            </ul>
          </div>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger disabled' @click.self="deleteOrders()" data-href='#'>{{translations('common.delete')}}</a>
            </div>
          </div>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <!-- <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="defaultCheckTax" ref="defaultCheckTax" v-model="taxIncluded" @change="toggleTax()">
              <label class="form-check-label" for="defaultCheckTax">税込</label>
            </div> -->
            <div v-if="taxIncluded" class="text-danger">{{translations('common.tax_included')}}</div><!-- TAXSTATUS -->
            <div v-else>{{translations('common.tax_excluded')}}</div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1100'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{translations('order.commodity_condition')}}</th>
                  <th>{{translations('order.jan_code')}}</th>
                  <th>{{translations('order.model')}}</th>
                  <th>{{translations('order.tax_classification')}}</th><!-- TAXSTATUS -->
                  <th>{{translations('order.quantity')}}</th>
                  <th>{{translations('order.unit_price')}}</th>
                  <th>{{translations('order.product_cost')}}</th>
                  <th>{{translations('order.client_order_number')}}</th>
                  <th>{{translations('order.summary')}}</th>
                  <th>{{translations('order.product_internal_memo')}}</th>
                  <th>{{translations('order.unit_price_total')}}</th>
                  <th>{{translations('order.total_cost')}}</th>
                  <th>{{translations('order.total_profit')}}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(detail, i) in ordersDetails">
                  <tr :key="i">
                    <td>
                      <button @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>
                    <td>{{ Number(detail.is_outlet) ? translations('order.outlet') : Number(detail.is_bad) ? translations('order.bad') : translations('order.good') }}</td>
                    <td>{{ detail.jan_code }}</td>
                    <td>{{ detail.type_number }}</td>
                    <td>
                      <select
                       :disabled="false"
                        v-model="detail.taxclass_id"
                        v-validate="'required'"
                        data-vv-name="taxclass_id"
                        data-vv-as="税区分"
                        class="custom-select width-100-px"
                        required
                        @change="onchangeTaxclass"
                      >
                        <option value="1">{{translations('order.taxable_item')}}</option>
                        <option value="2">{{translations('order.not_applicable')}}</option>
                      </select>
                    </td><!-- TAXSTATUS -->
                    <td class="right">{{ Number(detail.quantity).toLocaleString() }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'unit_price') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'row_price') }}</td>
                    <td>{{ detail.client_order_number }}</td>
                    <td>{{ detail.remarks }}</td>
                    <td>{{ detail.internal_memo }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_cost') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_profit') }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                    <button
                      class='btn-change plus'
                      type='button'
                      data-toggle='modal'
                      data-target='#OrdersDetailsModal'
                      @click="showModal"
                    >
                      <i></i>
                    </button>
                  </td>
                  <td></td><!-- TAXSTATUS -->
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalCost, grandTotalCostIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalProfit, grandTotalProfitIncTax) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group'>
              <button class='btn btn-sm btn-primary' @click="addOrders()">{{translations('common.update')}}</button>
            </div>
            <div class="form-group">
              <a class="btn btn-link btn-sm decoration-underline disabled" href="#">{{translations('order.delivery_slip_output')}}<i class="fas fa-external-link-alt"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <OrdersDetailsModal :details="ordersDetails" :clients_id="client_id" :ordersInfo="ordersInfo" :tax="{taxIncluded:taxIncluded, taxRate:taxRate}"/><!-- VAT -->
    <NewOrdersFileModal :poFile="poFile"/>
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import OrdersDetailsModal from '@/components/OrdersDetailsModal'
import NewOrdersFileModal from '@/components/NewOrdersFileModal'
import { DivisionType } from '../constants'
import DivisionTypeText from '@/components/orders/DivisionTypeText'
import { mapState } from 'vuex'

export default {
  name: 'NewOrders',
  props: {},
  components: {
    VueElementLoading,
    OrdersDetailsModal,
    NewOrdersFileModal,
    DivisionTypeText
  },

  data () {
    return {
      changeInfoTemp: 1,
      outsourcingstatus: 0,
      taxRate: 0, // VAT
      taxIncluded: false, // VAT
      ordersID: 0,
      billings: [],
      destinations: [],
      ordersInfo: {},
      ordersDetails: [],
      tempInfo: {},
      warehouses: [],
      usersList: [],
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalCost: 0,
      grandTotalCostIncTax: 0,
      grandTotalProfit: 0,
      grandTotalProfitIncTax: 0,
      isLoading: false,
      poFile: null,
      client_id: 0,
      DivisionTypes: []
    }
  },

  watch: {
    ordersDetails: {
      handler (v) {
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })
        this.calcGrandTotals()
      },
      deep: true
    },
    'tempInfo.client': {
      handler (newVal, oldVal) {
        if (!newVal) return
        if ((newVal && oldVal) && (newVal.id === oldVal.id)) return

        this.tempInfo.client_id = newVal.id
        this.updateField('destination_id', '', 'info05')
        this.listDestinations()
        this.getEmployeeByCompany()
      },
      deep: true
    },
    currentLanguage () {
      this.updateDivisionTypes()
    }
  },

  created () {
    this.getVatRate() // VAT
    this.getSequence()
    this.listBillings()
    this.listWarehouses()
    this.listUsers()
    this.ordersInfo.ordered_at = this.$invoiceTools.getCurrentDate()
    this.tempInfo.ordered_at = this.ordersInfo.ordered_at
    setTimeout(() => {
      this.popoverButtons()
    }, 1500)
    this.tempInfo.division_type_select = 'A'
    this.tempInfo.division_type = 'A'
    this.ordersInfo['division_type'] = 'A'
    this.updateDivisionTypes()
  },

  computed: {
    ...mapState(['currentLanguage']),
    confirmationAddOrderMessage () {
      return this.translations('order.save_order')
    },
    confirmationDeleteOrderMessage () {
      return this.translations('order.delete_order')
    },
    confirmButtonText () {
      return this.translations('common.yes')
    },
    cancelButtonText () {
      return this.translations('common.no')
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    updateDivisionTypes () {
      this.DivisionTypes = DivisionType
        .filter(divisionType => divisionType.value !== 'E')
        .map(divisionType => ({
          ...divisionType,
          label: this.translations(`order_status.${divisionType.label}`)
        }))
    },
    async listWarehouses () {
      try {
        let { data } = await this.$http.post(`${this.$api_url.warehouse_list}?typeB=true`)
        if (data.status === true) {
          this.warehouses = data.list
        } else {
          this.warehouses = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }
    },
    async listUsers () {
      try {
        let { data } = await this.$http.post(this.$api_url.account_user_list)
        if (data.status === true) {
          this.usersList = data.list
        } else {
          this.usersList = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }
    },
    divisionRenderText (divisonType) {
      for (let index = 0; index < DivisionType.length; index++) {
        const element = DivisionType[index]
        if (element.value === divisonType) {
          return this.translations(`order_status.${element.label}`)
        }
      }
      return '-----------'
    },
    async listBillings () {
      try {
        let cList = await this.$http.post(this.$api_url.bill_to_list)
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'NewOrders:listBillings')
        if ($data.success === true) {
          this.billings = $data.data
        } else {
          this.billings = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('NewOrders:listBillings:catch(error): ', error)
        this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }
    },
    async listDestinations () {
      try {
        let cList = await this.$http.post(
          this.$api_url.destinations_list,
          { client_id: this.tempInfo.client ? this.tempInfo.client.id : '' }
        )
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'NewOrders:listDestinations')
        if ($data.success === true) {
          this.destinations = $data.data
        } else {
          this.destinations = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('NewOrders:listDestinations:catch(error): ', error)
        this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }
    },
    async getSequence () {
      try {
        let result = await this.$http.post(this.$api_url.orders_sequence)
        // console.log(JSON.stringify(result))
        if (result.data.status === true) {
          this.tempInfo.order_number = result.data.sequence
          this.ordersInfo.order_number = result.data.sequence
          this.$refs['info03'].innerText = result.data.sequence
          this.$refs['input-info03'].value = result.data.sequence
        }
      } catch (error) {
        console.log('NewOrders:getSequence:catch(error): ', error)
        this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }
    },
    async getVatRate () { // VAT
      try {
        let result = await this.$http.post(this.$api_url.vat_rate)
        console.log(JSON.stringify(result.data))
        if (result.data.status === true) {
          this.taxRate = result.data.vat_rate
          // this.restoreTax()
        } else {
          this.$toastr.error(this.translations('order.notice_tax_rate'), this.translations('common.error'))
          // this.taxIncluded = false
          this.$refs['defaultCheckTax'].disabled = true
        }
      } catch (error) {
        console.log('NewOrders:getVatRate:catch(error): ', error)
        this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }
    },
    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()} (${Number(valIncTax).toLocaleString()})`
      } else {
        return `${Number(valIncTax).toLocaleString()} (${Number(val).toLocaleString()})`
      }
    },
    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
        if (taxIncluded) {
          return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
        } else {
          return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
        }
      } else {
        if (!taxIncluded) { // 税込以外
          return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
        } else {
          return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
        }
      }
    },

    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    /**
     * @param field : orders information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref) {
      let $this = this
      let val = ''
      const rg = /^\s+$/
      if (!value || value === '-' || value === '' || rg.test(value) === true || typeof value === 'undefined') {
        if (field === 'ordered_at') {
          $this.$refs[ref].innerText = '-----------'
        } else {
          $this.$refs[ref].innerText = '-----------'
        }
        val = ''
      } else if (field === 'client_id') {
        this.billings.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
            $this.client_id = v.id
            $this.outsourcingstatus = v.outsourcingstatus // 委託先向けのUI切替 (0:非該当, 1:該当, 2:任意)
            $this.taxIncluded = Number(v.taxstatus) === 2 // 0:未設定(税抜), 1:税抜, 2:税込 // TAXSTATUS
          }
        })
      } else if (field === 'destination_id') {
        val = 0 // DEFAULT // WARNING: DBがint型のため''ではエラーが発生する場合、該当selectのデフォルト値に0をセットし、比較対象が0件でも0になるよう初期値に0をセット
        this.destinations.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'ordered_at') {
        const x = /-/gi
        $this.$refs[ref].innerText = value.replace(x, '/')
        val = value.replace(x, '/')
      } else if (field === 'division_type') {
        this.tempInfo.division_type = value
        this.ordersInfo[field] = value
        $this.$refs[ref].innerText = this.divisionRenderText(value)
        val = value
      } else if (field === 'warehouse_id') {
        this.ordersInfo['warehouse_address'] = value.name
        $this.$refs[ref].innerText = this.ordersInfo['warehouse_address']
        this.ordersInfo[field] = value.id
        val = value
      } else if (field === 'warehouse_id_from') {
        this.ordersInfo['warehouse_address_from'] = value.name
        $this.$refs[ref].innerText = this.ordersInfo['warehouse_address_from']
        this.ordersInfo[field] = value.id
        val = value
      } else if (field === 'users_in_charge') {
        this.ordersInfo['users_in_charge'] = value.user_name
        $this.$refs[ref].innerText = this.ordersInfo['users_in_charge']
        this.ordersInfo[field] = value.id
        val = value
      } else {
        this.$refs[ref].innerText = value
        val = value
      }
      this.ordersInfo[field] = val
      this.changeInfoTemp = this.changeInfoTemp + 1
      window.$('#popover-' + ref).popoverX('hide')
    },

    closeModal (ref) {
      if (ref) window.$('#popover-' + ref).popoverX('hide')
    },

    deleteDetail (i) {
      this.ordersDetails.splice(i, 1)
    },

    showModal () {
      this.$root.$emit('bv::show::modal', 'OrdersDetailsModal')
    },

    prepareDetails (data, hasCost = false) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price
      data.total_profit = data.total_unit_price - data.total_cost

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
        data.total_profit_inctax = data.total_profit
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
        data.total_profit_inctax = this.$util.getIncludeTax(data.total_profit, data.tax_rate)
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalUnitPriceIncTax = 0
      this.grandTotalCost = 0
      this.grandTotalCostIncTax = 0
      this.grandTotalProfit = 0
      this.grandTotalProfitIncTax = 0

      this.ordersDetails.forEach(v => {
        this.grandTotalUnitPrice += Number(v.total_unit_price)
        this.grandTotalCost += Number(v.total_cost)
      })

      this.grandTotalProfit = this.grandTotalUnitPrice - this.grandTotalCost

      this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
      this.grandTotalCostIncTax = this.$util.getIncludeTax(this.grandTotalCost, this.taxRate)
      this.grandTotalProfitIncTax = this.grandTotalUnitPriceIncTax - this.grandTotalCostIncTax
    },

    addOrders () {
      if (!this.ordersInfo.ordered_at) {
        this.$toastr.warning(this.translations('order.notice_order_date'))
        return
      }

      if (!this.ordersInfo.order_number) {
        this.$toastr.warning(this.translations('order.notice_order_number'))
        return
      }
      if (this.ordersInfo.division_type === 'B') {
        if (!this.ordersInfo.warehouse_id) {
          this.$toastr.warning(this.translations('order.notice_delivery_source'))
          return
        }
        if (!this.ordersInfo.warehouse_id_from) {
          this.$toastr.warning(this.translations('order.notice_delivery_source'))
          return
        }

        if (this.ordersInfo.warehouse_id_from === this.ordersInfo.warehouse_id) {
          this.$toastr.warning(this.translations('order.notice_same_delivery_destination'))
          return
        }
      } else {
        if (!this.ordersInfo.client_id) {
          this.$toastr.warning(this.translations('order.notice_shipping_address'))
          return
        }
      }

      if (this.ordersDetails.length === 0) {
        this.$toastr.warning(this.translations('order.notice_enter_details_line'))
        return
      }
      this.$dialog.confirm(this.confirmationAddOrderMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      }).then(async () => {
        try {
          if (this.poFile != null) {
            this.ordersInfo.purchase_order_file = this.poFile
          } else {
            this.ordersInfo.purchase_order_file = ''
          }

          this.isLoading = true

          // const self = this
          this.ordersDetails.forEach(function (item) {
            item.row_price = String(item.row_price) // String for Phalcon(DECIMAL10,2)
          })
          if (this.ordersInfo.division_type === 'B') {
            this.ordersInfo.destination_name_warehouse = this.ordersInfo.warehouse_address
            this.ordersInfo.client_id = 0
          }

          let paramUpdate = {
            information: this.ordersInfo,
            details: this.ordersDetails
          }

          let updateOrder = await this.$http.post(this.$api_url.orders_add, paramUpdate)
          let $data = this.$invoiceTools.prepareResult(updateOrder.data)

          if ($data.success === true) {
            this.$toastr.success(this.translations('order.notice_order_save_success'), this.translations('common.success'))
            this.$router.replace('archive-orders')
          } else {
            this.$toastr.error($data.data, this.translations('common.error'))
          }
          this.isLoading = false
        } catch (error) {
          this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
        }
      })
    },

    openPdf () {
      if (this.poFile != null) {
        let arrBuff = this.__b64ToArrayBuffer(this.poFile.replace('data:application/pdf;base64,', ''))
        const pdfFile = new Blob([arrBuff], { type: 'application/pdf' })
        const pdfFileURL = URL.createObjectURL(pdfFile)
        window.open(pdfFileURL)
      }
    },

    deleteOrders () {
      let $this = this
      this.$dialog.confirm(this.confirmationDeleteOrderMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      }).then(async () => {
        this.isLoading = true
        try {
          let del = await this.$http.post(this.$api_url.orders_delete, { orders_id: $this.ordersID })
          let $data = this.$invoiceTools.prepareResult(del.data, '', 'NewOrders:deleteOrders')
          if ($data.success === true) {
            this.$toastr.success(this.translations('order.notice_delete_order_success'), this.translations('common.success'))
            this.isLoading = false
            this.$router.replace('archive-orders')
          } else {
            this.$toastr.error($data.data, this.translations('common.error'))
          }
          $this.isLoading = false
        } catch (error) {
          $this.isLoading = false
          console.log('NewOrders:deleteOrders:catch(error): ', error)
          this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
        }
      }).catch(() => { console.log('Clicked `Cancel`') })
    },
    onchangeTaxclass () {
      this.ordersDetails.forEach((detail, i) => {
        if (typeof detail !== 'undefined') {
          // this.ordersDetails[i] = this.prepareDetails(detail)
          this.ordersDetails[i] = this.prepareDetails(detail)
        }
      })
      this.calcGrandTotals()
    },
    async getEmployeeByCompany () {
      try {
        const { data: { data, status } } = await this.$http.post(this.$api_url.employee_by_company, { company_id: this.tempInfo.client_id })
        if (status) {
          this.$set(this.tempInfo, 'end_user', data)
          this.updateField('end_user', data, 'info06')
        }
      } catch (error) {}
    }
  }
}
</script>
<style>
  .warehouse_style .vs__selected{
      width: 145px;
  }
  .warehouse_style .v-select.vs--searchable .vs__dropdown-toggle {
    height: auto;
  }
</style>
